module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Med.woff2?v=085556e99e98fde753205f89261bcc6c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Med.woff2
// module id = 664
// module chunks = 0